import { areIntervalsOverlapping } from "date-fns";
import { IVirtualTrip } from "../../../common/plannerTypes";
import { getDateTime } from "../planner/plannerHelpers";
import { ConflictDialogData, ConflictType, IntervalNumbers } from "../types/conflictNoticeTypes";
import { IPlannerMinute, ITripPlanner } from "../types/plannerTypes";
import api from "../../../store/api";
const checkIfOverlap = (tripPlanner: ITripPlanner, trips: IVirtualTrip[], updatedVirtualTrip: IVirtualTrip): ConflictDialogData | null => {
  for (const trip of trips) {
    if (trip.virtualTripId === updatedVirtualTrip.virtualTripId) continue;

    const isOverlapping = areIntervalsOverlapping(
      { start: updatedVirtualTrip.startTrip, end: (updatedVirtualTrip.isTripMinOverrided ? updatedVirtualTrip.overridedendTrip : updatedVirtualTrip.endTrip) },
      { start: trip.startTrip, end: (trip.isTripMinOverrided ? trip.overridedendTrip : trip.endTrip) }
    );
    if (isOverlapping){
     localStorage.setItem("IsOverlapTransferPresent","true");
      return {
        conflictType: ConflictType.overlap,
        tripPlanner: tripPlanner,
      };
    }
  }
  localStorage.setItem("IsOverlapTransferPresent","false");
  return null;
};

const isOverlaping = (interval1: IntervalNumbers, interval2: IntervalNumbers) =>
  (interval2.start <= interval1.start && interval2.end >= interval1.start) ||
  (interval2.start <= interval1.end && interval2.end >= interval1.end) ||
  (interval2.start > interval1.start && interval2.end < interval1.end);

const calcOverlapSize = (interval1: IntervalNumbers, interval2: IntervalNumbers): number =>
  isOverlaping(interval1, interval2) ? Math.min(interval1.end, interval2.end) - Math.max(interval1.start, interval2.start) : 0;

const dateToMinutes = (date: Date): number => date.getHours() * 60 + date.getMinutes();

const checkIfLuchBreakOverlaped = (tripPlanner: ITripPlanner, trips: IVirtualTrip[], updatedVirtualTrip: IVirtualTrip): ConflictDialogData | null => {
  if (!tripPlanner.plannerBreakStartTime || !tripPlanner.plannerMaxBreakDelay || !tripPlanner.plannerBreakDuration) return null;
  const breakInterval = {
    start: tripPlanner.plannerBreakStartTime,
    end: tripPlanner.plannerMaxBreakDelay * 60 + tripPlanner.plannerBreakStartTime,
  };
  const maxAvailableBreak = tripPlanner.plannerMaxBreakDelay * 60 - tripPlanner.plannerBreakDuration;
  const updatedVirtualTripInterval = {
    start: dateToMinutes(updatedVirtualTrip.startTrip),
    end: dateToMinutes((updatedVirtualTrip.isTripMinOverrided ? updatedVirtualTrip.overridedendTrip : updatedVirtualTrip.endTrip)),
  };

  const updatedTripBreakOverlap = calcOverlapSize(breakInterval, updatedVirtualTripInterval);

  if (updatedTripBreakOverlap === 0) return null;

  const luchBreakOverlaped = {
    conflictType: ConflictType.lunchBreak,
    tripPlanner: tripPlanner,
  };

  let availableBreak = maxAvailableBreak - updatedTripBreakOverlap;

  if (availableBreak < 0) return luchBreakOverlaped;

  for (const trip of trips) {
    if (trip.virtualTripId === updatedVirtualTrip.virtualTripId) continue;
    const tripInterval = {
      start: dateToMinutes(trip.startTrip),
      end: dateToMinutes((trip.isTripMinOverrided ? trip.overridedendTrip : trip.endTrip)),
    };
    const tripOverlap = calcOverlapSize(breakInterval, tripInterval);
    availableBreak = availableBreak - tripOverlap;
    if (availableBreak < 0) return luchBreakOverlaped;
  }
  return null;
};

const checkIfShiftend = (interval1Day: string, tripPlanner: ITripPlanner, updatedVirtualTrip: IVirtualTrip): ConflictDialogData | null => {
  if (!tripPlanner.plannerEndTime) return null;

  if (updatedVirtualTrip.isTripMinOverrided && (updatedVirtualTrip.overridedendTrip > getDateTime(interval1Day, tripPlanner.plannerEndTime)) ) {
    return {
      conflictType: ConflictType.shiftEnd,
      tripPlanner: tripPlanner,
    };
  }
  else if (!updatedVirtualTrip.isTripMinOverrided && (getDateTime(interval1Day, tripPlanner.plannerEndTime!!) < (updatedVirtualTrip.endTrip))) {
    return {
      conflictType: ConflictType.shiftEnd,
      tripPlanner: tripPlanner,
    };
  }

  return null;
};

const getAcuityNumber = (letter: string) => {
  if (letter === "A") return 0;
  else if (letter === "B") return 1;
  else if (letter === "C") return 2;
  else if (letter === "D") return 3;
  else if (letter === "H") return 5;
  else if (letter === "M") return 6;
  else if (letter === "L") return 7;
  else return 8;
};

export const checkAcuity = (plannerAcuity: string | null, transferAcuity: number | null): ConflictDialogData | null => {
  const plannerAcuityArray = plannerAcuity?.split(",").sort()
  
  var highestAcuityVIC = "";
  if(plannerAcuityArray!.indexOf("L") == 0 || plannerAcuityArray!.indexOf("L") > 0) highestAcuityVIC = "L";
  if(plannerAcuityArray!.indexOf("M") == 0 || plannerAcuityArray!.indexOf("M") > 0) highestAcuityVIC = "M";
  if(plannerAcuityArray!.indexOf("H") == 0 || plannerAcuityArray!.indexOf("H") > 0) highestAcuityVIC = "H";

  const highestAcuityOtherStates = plannerAcuity?.split(",").sort()[0] || "";

  const highestAcuityNumberOtherStates = getAcuityNumber(highestAcuityOtherStates);
  const highestAcuityNumberVIC = getAcuityNumber(highestAcuityVIC);
  
  let isVIC = transferAcuity! >= 5 ? true : false;
  if(isVIC) {
    if (!transferAcuity || transferAcuity < highestAcuityNumberVIC) {
      return {
        conflictType: ConflictType.wrongAcuity,
      };
    }
  }
  else {
    if (!transferAcuity || transferAcuity < highestAcuityNumberOtherStates) {
      return {
        conflictType: ConflictType.wrongAcuity,
      };
    }
  }
  
  return null;
};
export const checkuserpermission = (role: string | null, userpermission: boolean|null): ConflictDialogData | null => {  
  if(role == null)
  {
    role ="Primary"
  }
  if (role ==="Primary" && userpermission !== true) {
    return {
      conflictType: ConflictType.Allow,
    };
  }
  if (role ==="Secondary" && userpermission !== true) {
    return {
      conflictType: ConflictType.Allow,
    };
  }
  return null;
};
export const checkuserpermissionReschedule = (role: string | null, userpermission: boolean|null): ConflictDialogData | null => {  
  if(role == null)
  {
    role ="Primary"
  }
  if (role ==="Primary" && userpermission !== true) {
    return {
      conflictType: ConflictType.Reschedule,
    };
  }
  if (role ==="Secondary" && userpermission !== true) {
    return {
      conflictType: ConflictType.Reschedule,
    };
  }
  return null;
};
export const checkuserpermissiontransfer = (user:any): ConflictDialogData | null => {  
   return {
      conflictType: ConflictType.Allow,
    };
};
export const checkuserpermissionforAdhoc = (user: any): ConflictDialogData | null => {
    if (!user) {
        return {
            conflictType: ConflictType.Allow,
        };
    }
    return null;
};
const checkConflictsForUpdatedTrip = (
  interval1Day: string,
  tripPlanner: ITripPlanner,
  scheduledTimelineTrips: IVirtualTrip[],
  updatedVirtualTrip: IVirtualTrip,
  userid:string,
): ConflictDialogData | null => {
  return (
    checkIfOverlap(tripPlanner, scheduledTimelineTrips, updatedVirtualTrip) ||
    checkIfLuchBreakOverlaped(tripPlanner, scheduledTimelineTrips, updatedVirtualTrip) ||
    checkIfShiftend(interval1Day, tripPlanner, updatedVirtualTrip)
    
  );
};

const formatToMinutesHours = (totalMinutes: number) => {
  const minutes = `0${totalMinutes % 60}`.slice(-2);
  const hours = `0${Math.floor(totalMinutes / 60)}`.slice(-2);
  return `${hours}:${minutes}`;
};

const checkIfOverlapForTrips = (trips: IVirtualTrip[], tripsForCheck: IVirtualTrip[]): boolean => {
  for (const tripForCheck of tripsForCheck) {
    if (tripForCheck.deletedFromTimeLine) continue;
    const overlappingTrip = trips.find(
      (tr) =>
        tr.virtualTripId !== tripForCheck.virtualTripId &&
        tr.tripPlannerId &&
        tr.tripPlannerId === tripForCheck.tripPlannerId &&
        areIntervalsOverlapping({ start: tripForCheck.startTrip, end: tripForCheck.endTrip }, { start: tr.startTrip, end: tr.endTrip })
    );
    
    if (overlappingTrip) return true;
  }
  return false;
};

export { checkConflictsForUpdatedTrip, formatToMinutesHours, checkIfOverlapForTrips };
